<script lang="ts">
    import { melt } from '@melt-ui/svelte';
    import {
        VpWalkIcon,
        VpMapPinIcon,
        VpCalendarIcon,
        VpChevronRightIcon,
    } from '@decathlon-experience/icons/svelte';

    import { FilterType } from '$saga/views/Search/types';
    import hiking from '$saga/icons/sports/hiking.svg';
    import mountaineering from '$saga/icons/sports/mountaineering.svg';
    import snowshoeing from '$saga/icons/sports/snowshoeing.svg';
    import { filtersContext } from '$saga/views/Search/store';

    export let trigger, handleSelectedFilter;

    let floatingSearch: HTMLDivElement | null = null;
</script>

<div
    class="relative flex gap-xs p-l transition-transform duration-300 desktop:hidden"
    style={floatingSearch?.clientHeight != null
        ? `height: ${floatingSearch.clientHeight * 0.4}px`
        : ''}
>
    <div
        bind:this={floatingSearch}
        class="absolute bottom-0 left-0 mx-l flex w-[calc(100%_-_40px)] flex-col items-center justify-center gap-xs rounded-[12px] border border-solid border-border-quiet bg-white p-m"
    >
        <div class="flex w-full flex-col gap-xs">
            <div class="w-full bg-container-quiet px-m py-xs">
                <div class="mb-xs flex items-center gap-xs">
                    <VpWalkIcon size={16} />
                    <span class="font-semibold">Sport</span>
                </div>
                <div class="flex justify-evenly sm:justify-start sm:gap-2xl">
                    <div
                        class="flex flex-1 flex-col items-center gap-2xs sm:flex-initial"
                    >
                        <button
                            on:click|preventDefault|stopPropagation={() => {
                                handleSelectedFilter(FilterType.SPORT);
                                const sport =
                                    $filtersContext?.defaultSportOptions?.find(
                                        (sportOption) =>
                                            sportOption.value === '5', // Randonnée
                                    );
                                if (sport) {
                                    $filtersContext.formValues.theme = [
                                        sport.value,
                                    ];
                                    $filtersContext.formLabels.theme = [
                                        sport.label,
                                    ];
                                }
                            }}
                            {...$trigger}
                            use:trigger
                            class="flex h-fit w-fit items-center justify-center rounded-[12px] bg-white p-xs shadow-light"
                        >
                            <img
                                src={hiking}
                                alt="Randonnée"
                                class="size-3xl"
                            />
                        </button>
                        <span class="text-center text-xs">Randonnée</span>
                    </div>
                    <div
                        class="flex flex-1 flex-col items-center gap-2xs sm:flex-initial"
                    >
                        <button
                            on:click|preventDefault|stopPropagation={() => {
                                handleSelectedFilter(FilterType.SPORT);
                                const sport =
                                    $filtersContext?.defaultSportOptions?.find(
                                        (sportOption) =>
                                            sportOption.value === '15', // raquettes a neige
                                    );
                                if (sport) {
                                    $filtersContext.formValues.theme = [
                                        sport.value,
                                    ];
                                    $filtersContext.formLabels.theme = [
                                        sport.label,
                                    ];
                                }
                            }}
                            {...$trigger}
                            use:trigger
                            class="flex h-fit w-fit items-center justify-center rounded-[12px] bg-white p-xs shadow-light"
                        >
                            <img
                                src={snowshoeing}
                                alt="Raquettes à neige"
                                class="size-3xl"
                            />
                        </button>
                        <span class="text-center text-xs">Raquettes</span>
                    </div>
                    <div
                        class="flex flex-1 flex-col items-center gap-2xs sm:flex-initial"
                    >
                        <button
                            on:click|preventDefault|stopPropagation={() => {
                                handleSelectedFilter(FilterType.SPORT);
                                const sport =
                                    $filtersContext?.defaultSportOptions?.find(
                                        (sportOption) =>
                                            sportOption.value === '8', // Alpinisme
                                    );
                                if (sport) {
                                    $filtersContext.formValues.theme = [
                                        sport.value,
                                    ];
                                    $filtersContext.formLabels.theme = [
                                        sport.label,
                                    ];
                                }
                            }}
                            {...$trigger}
                            use:trigger
                            class="flex h-fit w-fit items-center justify-center rounded-[12px] bg-white p-xs shadow-light"
                        >
                            <img
                                src={mountaineering}
                                alt="Alpinisme"
                                class="size-3xl"
                            />
                        </button>
                        <span class="text-center text-xs">Alpinisme</span>
                    </div>
                    <div
                        class="flex flex-1 flex-col items-center gap-2xs sm:flex-initial"
                    >
                        <button
                            on:click|preventDefault|stopPropagation={() => {
                                handleSelectedFilter(FilterType.SPORT);
                            }}
                            {...$trigger}
                            use:trigger
                            class="flex h-fit w-fit items-center justify-center rounded-[12px] bg-white p-xs shadow-light"
                        >
                            <span class="h-3xl w-3xl text-[28px] font-semibold"
                                >...</span
                            >
                        </button>
                        <span class="text-center text-xs">Autre sport</span>
                    </div>
                </div>
            </div>
            <button
                on:click|preventDefault|stopPropagation={() => {
                    handleSelectedFilter(FilterType.DESTINATION);
                }}
                {...$trigger}
                use:trigger
                class="w-full bg-container-quiet px-m py-xs"
            >
                <span class="flex items-center gap-xs">
                    <VpMapPinIcon size={16} />
                    <span class="font-semibold">Destination</span>
                    <VpChevronRightIcon size={16} class="ml-auto" />
                </span>
            </button>
            <button
                on:click|preventDefault|stopPropagation={() => {
                    handleSelectedFilter(FilterType.STARTDATE);
                }}
                {...$trigger}
                use:trigger
                class="w-full bg-container-quiet px-m py-xs"
            >
                <span class="flex items-center gap-xs">
                    <VpCalendarIcon size={16} />
                    <span class="font-semibold">Dates de départ</span>
                    <VpChevronRightIcon size={16} class="ml-auto" />
                </span>
            </button>
        </div>
        <button
            class="vp-button vp-button-small vp-button--squared w-full normal-case"
            use:melt={$trigger}
        >
            <span class="flex items-center gap-xs">Rechercher un séjour </span>
        </button>
    </div>
</div>
